import { Timer } from './Timer';

export class DoorTimer {

    constructor(
        public id?: number,
        public timer?: Timer,
        public durability?: number
    ) {

    }

    public static fromData(data: any) {
        if (!data) return null;
        let o: DoorTimer = new DoorTimer(
            data.id,
            Timer.fromData(data.timer),
            data.durability
        )
        return o;
    }
    get time() {
        return this.timer.time;
    }
    get timeStr() {
        return this.timer.value;
    }
}